/**
 * Manual box office and Rotten Tomatoes data for films in the Box Office Rail.
 * This data is used to augment films that don't have data from our theatrical releases API.
 *
 */

export interface ManualFilmData {
  /** Rotten Tomatoes critics score (0-100) - only for non-Angel Original films */
  rottenTomatoesCritics?: number | null
  /** Rotten Tomatoes audience score (0-100) - only for non-Angel Original films */
  rottenTomatoesAudience?: number | null
  /** Override release date if needed (YYYY-MM-DD format) */
  releaseDate?: string | null
}

/**
 * Manual film data keyed by project slug.
 * Add entries here to provide box office and RT data for films in the collection.
 */
export const manualFilmData: Record<string, ManualFilmData> = {
  // Example entries - update with real data
  homestead: {
    rottenTomatoesCritics: null,
    rottenTomatoesAudience: null,
  },
  'king-of-kings': {
    rottenTomatoesCritics: null,
    rottenTomatoesAudience: null,
  },
  'last-rodeo': {
    rottenTomatoesCritics: null,
    rottenTomatoesAudience: null,
  },
  'the-shift': {
    rottenTomatoesCritics: null,
    rottenTomatoesAudience: null,
  },
  'faith-of-angels': {
    rottenTomatoesCritics: null,
    rottenTomatoesAudience: 94,
  },
  'truth-and-treason': {
    rottenTomatoesCritics: null,
    rottenTomatoesAudience: null,
  },
  'thank-you-dr-fauci': {
    rottenTomatoesCritics: null,
    rottenTomatoesAudience: 86,
  },
  'green-and-gold': {
    rottenTomatoesCritics: 67,
    rottenTomatoesAudience: 98,
  },
  'sound-of-hope-the-story-of-possum-trot': {
    rottenTomatoesCritics: null,
    rottenTomatoesAudience: null,
  },
  'his-only-son': {
    rottenTomatoesCritics: null,
    rottenTomatoesAudience: null,
  },
  sketch: {
    rottenTomatoesCritics: null,
    rottenTomatoesAudience: null,
  },
  'after-death': {
    rottenTomatoesCritics: null,
    rottenTomatoesAudience: null,
  },
  senior: {
    rottenTomatoesCritics: null,
    rottenTomatoesAudience: null,
  },
  'brave-the-dark': {
    rottenTomatoesCritics: null,
    rottenTomatoesAudience: null,
  },
  'sound-of-freedom': {
    rottenTomatoesCritics: null,
    rottenTomatoesAudience: null,
  },
  bonhoeffer: {
    rottenTomatoesCritics: null,
    rottenTomatoesAudience: null,
  },
  cabrini: {
    rottenTomatoesCritics: null,
    rottenTomatoesAudience: null,
  },
  'lost-on-a-mountain-in-maine': {
    rottenTomatoesCritics: 53,
    rottenTomatoesAudience: 82,
  },
  'raising-the-bar': {
    rottenTomatoesCritics: null,
    rottenTomatoesAudience: null,
  },
  grow: {
    rottenTomatoesCritics: 93,
    rottenTomatoesAudience: 97,
  },
  'something-to-stand-for-with-mike-rowe': {
    rottenTomatoesCritics: 80,
    rottenTomatoesAudience: 98,
  },
  'escape-from-germany': {
    rottenTomatoesCritics: 80,
    rottenTomatoesAudience: 98,
  },
  'rule-breakers': {
    rottenTomatoesCritics: null,
    rottenTomatoesAudience: null,
  },
  sight: {
    rottenTomatoesCritics: null,
    rottenTomatoesAudience: null,
  },
}

/**
 * Gets manual film data for a given slug, or undefined if not found
 */
export function getManualFilmData(slug: string): ManualFilmData | undefined {
  return manualFilmData[slug]
}
